import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { EDIT_MESSAGE, PREVIEW_MESSAGE, PREVIEW_SLUG } from "../../lib/productPreview";
import { LivePreviewFrame } from "./LivePreviewFrame";

/** The real public product page, fed with the unsaved product draft and its page layout. */
export const ProductLivePreview = ({ product, layout, onEdit, height = "72vh" }) => {
    const payload = useMemo(() => ({ product, layout }), [product, layout]);
    return (
        <LivePreviewFrame testId="product-live-preview" title="Product preview"
            path={`/product/${product?.slug || PREVIEW_SLUG}?preview=1`}
            payload={payload} message={PREVIEW_MESSAGE} editMessage={EDIT_MESSAGE} onEdit={onEdit}
            liveUrl={product?.slug ? `/product/${product.slug}` : ""}
            note="CLICK ANY TEXT TO EDIT" height={height} />
    );
};

export default ProductLivePreview;
